import EfImg from 'elem/ui/ef-img';
import EfSpec from 'elem/ui/ef-spec';
import { Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('dp3.landing.EU3');
    const imgArr = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724295064961/Frame%201000008559.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1724295064961/Frame%201000008559.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725178243374/h5-dp3-independently.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724295064909/Frame%201000008359.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1724295064909/Frame%201000008359.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725179943395/Frame%2010000089744.jpg',
        },
    ];

    return (
        <div className={`${css['thecomp']} GtmModuleData-section`} data-section-id={'dp3-EU3'} data-section-title={t('title')}>
            <EfSpec className="spec-x" />
            <p className="dp3-title title">{t('title')}</p>
            {/* <p className="dp3-desc desc">{t('desc')}</p> */}
            <Swiper
                className={`swiper-box ${imgArr?.length === 1 ? 'single' : ''}`}
                modules={[Scrollbar, Pagination, Navigation]}
                navigation={imgArr?.length > 1}
                pagination={imgArr?.length > 1}
                loop={imgArr?.length > 1}
                spaceBetween={0}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
            >
                {imgArr?.map((img: any, k: number) => {
                    return (
                        <SwiperSlide className={`swiper-item`} key={k}>
                            <EfImg pc={img?.pc} pad={img?.pad} h5={img?.h5} />
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
